import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: 8px;

  & > :nth-child(2) {
    align-self: flex-end;
  }
  & > :nth-child(1) {
    .ant-form-item {
      margin-bottom: 0;
      width: 100%;
    }
  }
`;
